import {PayMethod} from '@web/core/constants'
import {getNaverPayPointByApi} from '@web/pageHelpers/ordersheet'
import {getPoints, getRewardStatus} from '@web/slices/rewardPoint/slice'
import makeSlice from '@web/slices/rewardPoint/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
            const {rewardPoint} = payload.naverpayPoint ?? getNaverPayPointByApi()
            const {availablePayMethodTypes} = payload
            const isRewardPointAvailable = availablePayMethodTypes.includes(PayMethod.REWARD_POINT)

            state.amount = isRewardPointAvailable ? (rewardPoint.rewardPointBalance ?? 0) : 0
            state.cashPoint = isRewardPointAvailable ? (rewardPoint.cashableRewardPointBalance ?? 0) : 0
            state.status = getRewardStatus(rewardPoint.success)
            state.descriptions = isRewardPointAvailable
                ? getPoints({
                      totalBalance: rewardPoint.rewardPointBalance ?? 0,
                      points: rewardPoint.rewardPointDescriptions ?? [],
                  })
                : []
        })
    },
})

export default slice.reducer
